"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extend_1 = __importDefault(require("extend"));
var Analytics_1 = __importDefault(require("../Analytics"));
var TrackerUtil_1 = __importDefault(require("./TrackerUtil"));
var BasicTrackerAbstractImpl_1 = __importDefault(require("./BasicTrackerAbstractImpl"));
;
var GTag = /** @class */ (function (_super) {
    __extends(GTag, _super);
    function GTag(options) {
        var _this = _super.call(this, options) || this;
        _this.platformName = GTag.platformName;
        _this.isInterceptorSetup = false;
        _this.reportCurrentPageview = function () {
            // TODO: This is not going to report hash. Should we consider reporting that too? Maybe, maybe not.
            if (window.location.pathname !== _this.lastReportedCurrentPageviewPath) {
                _this.trackPageview(window.location.pathname);
            }
        };
        // Setup interceptor - So we can notify observers.
        _this.setupInterceptor();
        // Log an error if "send_page_view" is not false when "config" is set.
        // Since it can be set through a few methods we use a "get" method of gtag().
        _this.addObserver({
            update: function (tracker, data) {
                if (data.type === "config") {
                    var gtag_1 = _this.getPlatformInstance();
                    gtag_1("get", data.targetId, "send_page_view", function (value) {
                        if (value !== false) {
                            throw new Error("The \"config\" method of gtag() was called for \"" + data.targetId + "\" without \"send_page_view\" set to false. Must be set to false. See documentation for @plaudit/analytics for details.");
                        }
                    });
                }
            }
        });
        // On page ready report page
        if (document.readyState === "interactive" || document.readyState === "complete") {
            _this.reportCurrentPageview();
        }
        else {
            window.addEventListener("DOMContentLoaded", _this.reportCurrentPageview);
        }
        // Report to on location changes too.
        window.addEventListener("popstate", function () {
            // TODO: Should have an option to turn this off.
            _this.reportCurrentPageview();
        });
        // Log information
        _this.getLogger().debug(_this.platformName + " instance initialized.", "Options: ", options);
        return _this;
    }
    /**
     * @public
     */
    GTag.getInstance = function (options) {
        options = extend_1.default(true, {}, GTag.defaultOptions, options);
        if (!Analytics_1.default.isSetup()) {
            throw new Error("Analytics.setup() must be called once before you can get an instance of any tracker.");
        }
        var tracker = TrackerUtil_1.default.getInstance(options, GTag.instances, function (options) {
            return new GTag(options);
        }, function () {
            return window[options.globalKeyForPlatform] !== undefined && window.dataLayer !== undefined;
        });
        return tracker;
    };
    /**
     * @public
     */
    GTag.prototype.trackPageview = function (pagePath, title) {
        pagePath = TrackerUtil_1.default.pagePathCleanup(pagePath);
        var gtag = this.getPlatformInstance();
        var params = {
            page_title: title !== undefined ? title : document.title,
            page_path: pagePath
        };
        gtag("event", "page_view", params);
        this.lastReportedCurrentPageviewPath = pagePath;
        // Log
        this.getLogger().debug("GTag.trackPageview:", params);
    };
    /**
     * @public
     */
    GTag.prototype.trackEvent = function (category, action, label, value, nonInteraction) {
        var eventAction = TrackerUtil_1.default.eventActionToString(action);
        var params = {
            event_category: category
        };
        if (label !== undefined && label !== null) {
            params.event_label = TrackerUtil_1.default.eventLabelToString(label);
        }
        if (value !== undefined && value !== null) {
            params.value = value;
        }
        if (nonInteraction !== undefined && nonInteraction !== null) {
            params.non_interaction = nonInteraction;
        }
        var gtag = this.getPlatformInstance();
        gtag("event", eventAction, params);
        // Log
        this.getLogger().debug("GTag.trackEvent:", params);
    };
    /**
     * @private
     */
    GTag.prototype.getDataLayer = function () {
        return window.dataLayer; // TODO: This can be renamed: https://developers.google.com/tag-manager/devguide#renaming
    };
    /**
     * @private
     */
    GTag.prototype.setupInterceptor = function () {
        var _this = this;
        var dataLayer = this.getDataLayer();
        if (this.isInterceptorSetup === true) {
            return;
        }
        // Override the push() on dataLayer. This is what is called inside the gtag() method
        // Note: Overriding the push() is what Google deoes too.
        var previousPush = dataLayer.push;
        dataLayer.push = function () {
            var items = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                items[_i] = arguments[_i];
            }
            var result = previousPush.apply(dataLayer, items);
            items.forEach(function (dataLayerItem) {
                var data = GTag.dataLayerItemToObserverData(dataLayerItem);
                _this.notifyObservers(data);
            });
            return result;
        };
        this.isInterceptorSetup = true;
    };
    GTag.prototype.addObservers = function (observers, replayDataLayer) {
        var _this = this;
        if (replayDataLayer === void 0) { replayDataLayer = true; }
        if (this.observers === undefined) {
            this.observers = new Set();
        }
        observers.forEach(function (observer) { return _this.observers.add(observer); });
        if (replayDataLayer) {
            var dataLayer_1 = this.getDataLayer();
            dataLayer_1.forEach(function (dataLayerItem) {
                var data = GTag.dataLayerItemToObserverData(dataLayerItem);
                _this.notifyObservers(data, observers);
            });
        }
    };
    GTag.prototype.addObserver = function (observer, replayDataLayer) {
        if (replayDataLayer === void 0) { replayDataLayer = true; }
        this.addObservers([observer], replayDataLayer);
    };
    GTag.prototype.removeObserver = function (observer) {
        if (this.observers === undefined) {
            return;
        }
        this.observers.delete(observer);
    };
    GTag.prototype.notifyObservers = function (data, observers) {
        var _this = this;
        if (observers === void 0) { observers = this.observers; }
        if (observers === undefined) {
            return;
        }
        observers.forEach(function (observer) {
            observer.update(_this, data);
        });
        this.getLogger().debug("GTag.notifyObservers:", data, this.observers);
    };
    GTag.dataLayerItemToObserverData = function (dataLayerItem) {
        var data = null;
        // See documentation on dataLayer: https://developers.google.com/tag-manager/devguide
        if (dataLayerItem.length > 0 && dataLayerItem[0] !== undefined) { // Arguments are not an array so I can't finda better option then checking length to see if it is an "array" of arguments
            var type = dataLayerItem[0];
            // https://developers.google.com/gtagjs/reference/api
            if (type === "config") {
                //gtag('config', '<TARGET_ID>', {<additional_config_info>});
                data = {
                    type: type,
                    targetId: dataLayerItem[1],
                    config: dataLayerItem[2] // Could be undefined.
                };
            }
            else if (type === "get") {
                // gtag('get', '<target>', '<field_name>', callback)
                data = {
                    type: type,
                    targetId: dataLayerItem[1],
                    fieldName: dataLayerItem[2],
                    callback: dataLayerItem[3]
                };
            }
            else if (type === "set") {
                // gtag('set', '<target>', {<parameter-value-pair>, <parameter-value-pair>});
                // gtag('set', {<parameter-value-pair>, <parameter-value-pair>});
                if (typeof dataLayerItem[1] === "string") {
                    data = {
                        type: type,
                        targetId: dataLayerItem[1],
                        config: dataLayerItem[2]
                    };
                }
                else {
                    data = {
                        type: type,
                        config: dataLayerItem[1]
                    };
                }
            }
            else if (type === "js") {
                // gtag('js', new Date());
                data = {
                    type: type,
                    config: dataLayerItem[1]
                };
            }
            else if (type === "event") {
                // gtag('event', '<event_name>', {<event_params>});
                data = {
                    type: type,
                    eventName: dataLayerItem[1],
                    eventParams: dataLayerItem[2] // Could be undefined.
                };
            }
            else if (type === "consent") {
                // gtag('consent', {<consent_arg>}, {<consent_params>});
                data = {
                    type: type,
                    consentArg: dataLayerItem[1],
                    consentParams: dataLayerItem[2]
                };
            }
        }
        else {
            // Either an HTML event ({event: "event_name", ...}) or setting variable(s) ({"variable_name" : "variable_value", ...})
            // https://developers.google.com/tag-manager/devguide
            if (dataLayerItem.event !== undefined && typeof dataLayerItem.event === "string") {
                data = extend_1.default(true, { type: "htmlEvent" }, dataLayerItem);
            }
            else {
                data = extend_1.default(true, { type: "variables" }, dataLayerItem);
            }
        }
        return data;
    };
    GTag.platformName = "GTag";
    GTag.instances = new Map();
    GTag.defaultOptions = {
        globalKeyForPlatform: "gtag" // TODO: This could be renamed.
    };
    return GTag;
}(BasicTrackerAbstractImpl_1.default));
exports.default = GTag;
